export interface IPhoneConfirmationValidateRequest {
    sessionId: string,
    token: string,
}

export class PhoneConfirmationValidateRequest implements IPhoneConfirmationValidateRequest {
    sessionId: string = '';
    token: string = '';
}
